import { debounce } from 'es-toolkit';
import { Search, XIcon } from 'lucide-react';
import { memo, useCallback, useState } from 'react';
import { Input } from '@/components/ui/input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = memo(function SearchInput({
  value,
  onChange,
  placeholder = 'Search',
  className = '',
}: SearchInputProps) {
  const [localValue, setLocalValue] = useState(value);
  const debouncedOnChange = useCallback(debounce(onChange, 300), []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setLocalValue(newValue);
    debouncedOnChange(newValue);
  };

  const handleReset = () => {
    setLocalValue('');
    onChange('');
  };

  return (
    <div className={`relative flex flex-1 items-center ${className}`}>
      <Search className="pointer-events-none absolute left-3 text-muted-foreground" size={18} />
      <Input
        className="px-10"
        placeholder={placeholder}
        value={localValue}
        onChange={handleInputChange}
      />
      {Boolean(localValue) && (
        <XIcon
          className="absolute right-0.5 p-1.5 text-muted-foreground transition-colors hover:cursor-pointer hover:text-foreground"
          onClick={handleReset}
          size={32}
        />
      )}
    </div>
  );
});
